module.exports = __webpack_public_path__ + "img/user-cirlce-add.cc04acc3.svg";